"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var tooltip_style_1 = require("./tooltip.style");
// Note that if you pass content as react elements each React Element in the array has to have its unique key prop.
var Tooltip = function (_a) {
    var children = _a.children, content = _a.content, _b = _a.small, small = _b === void 0 ? false : _b, _c = _a.centeredText, centeredText = _c === void 0 ? false : _c;
    var _d = react_1.useState(false), open = _d[0], setOpen = _d[1];
    return (react_1.default.createElement(tooltip_style_1.Wrapper, { "data-test-id": 'tool-tip', onMouseEnter: function () { return setOpen(true); }, onMouseLeave: function () { return setOpen(false); } },
        children,
        open && (react_1.default.createElement(tooltip_style_1.ContentWrapper, { "data-test-id": 'tool-tip-content', small: small, centeredText: centeredText },
            react_1.default.createElement(tooltip_style_1.Arrow, null),
            content))));
};
exports.default = Tooltip;
//# sourceMappingURL=tooltip.js.map